import { useMemo } from "react";
import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { useApi } from "providers/ApiProvider";
import { DialButton } from "./DialButton";
import { PurposeItem } from "~/core/resources/registrationApi";
import useSWR from "swr";
import { Box } from "../commons/LandscapeSelect.styled";

export const LandscapeVisitPurposeSelect = () => {
  const { visitPurpose, setVisitPurpose } = useSimpleRegistrationContext();
  const { registrationApi } = useApi();
  const { data } = useSWR("visit-purpose", async () => {
    const response = await registrationApi.purposeList({
      limit: 12,
      visible: true,
      orderBy: "order desc",
    });
    return response.data || [];
  });

  const visitPurposeList = useMemo(() => {
    return data?.data || [];
  }, [data]);

  const onClickSelect = (purpose: PurposeItem) => {
    if (visitPurpose.indexOf(purpose) > -1) {
      const update = [...visitPurpose];
      update.splice(visitPurpose.indexOf(purpose), 1);
      setVisitPurpose(update);
    } else {
      const update = [...visitPurpose];
      update.push(purpose);
      setVisitPurpose(update);
    }
  };

  const VisitPurposesButtons = () => {
    const buttons = visitPurposeList.map((v) => (
      <DialButton
        key={v.id}
        text={v.name}
        disabled={visitPurpose.indexOf(v) === -1 && visitPurpose.length === 3}
        onClick={() => onClickSelect(v)}
        selected={visitPurpose.indexOf(v) > -1}
      />
    ));
    const divList = [];
    for (let i = 0; i < buttons.length; i += 3) {
      divList.push(
        <Box className="button-row" key={i}>
          {buttons.slice(i, i + 3)}
        </Box>
      );
    }
    return <>{divList}</>;
  };

  return (
    <Box className="container">
      <Box className="content">
        <Box className="title">
          <b>방문목적</b>을 선택하세요 (최대 3개)
        </Box>
        <Box className="buttons-container">
          <VisitPurposesButtons />
        </Box>
      </Box>
    </Box>
  );
};
